import { render, staticRenderFns } from "./expresscorp.vue?vue&type=template&id=0b6ad4bd&"
import script from "./expresscorp.vue?vue&type=script&lang=js&"
export * from "./expresscorp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports